module.exports = __webpack_public_path__ + "static/media/icon_lock.31957f97.png";